import { ColumnConfigKey } from "../types/page-config/column-customizer/ColumnConfigKey";

export const bwicColumnsLabels: { [key in ColumnConfigKey]: string } = {
    [ColumnConfigKey.IsinCusip]: 'Identifier',
    [ColumnConfigKey.Ticker]: 'Ticker',
    [ColumnConfigKey.Inventory]: 'Inventory',
    [ColumnConfigKey.Asset]: 'Asset',
    [ColumnConfigKey.Currency]: 'Ccy',
    [ColumnConfigKey.Rating]: 'Rtg',
    [ColumnConfigKey.Size]: 'Size, MM',
    [ColumnConfigKey.AddOn]: 'Add-on, MM',
    [ColumnConfigKey.PxTalk]: 'Px Talk',
    [ColumnConfigKey.Color]: 'Color Px',
    [ColumnConfigKey.ColorDm]: 'Color DM',
    [ColumnConfigKey.ColorWal]: 'WAL',
    [ColumnConfigKey.DealName]: 'Deal Name',
    [ColumnConfigKey.CollateralManager]: 'Manager',
    [ColumnConfigKey.ClosingDate]: 'Closing',
    [ColumnConfigKey.NcEnd]: 'NCE',
    [ColumnConfigKey.NcEndYrs]: 'Orig NCE, yrs',
    [ColumnConfigKey.OutOfNc]: 'Out of NC',
    [ColumnConfigKey.RiEnd]: 'RIE',
    [ColumnConfigKey.RiEndYrs]: 'Orig RIE, yrs',
    [ColumnConfigKey.OutOfRi]: 'Out of RI',
    [ColumnConfigKey.Maturity]: 'Maturity',
    [ColumnConfigKey.Vintage]: 'Vintage',
    [ColumnConfigKey.Trustee]: 'Trustee',
    [ColumnConfigKey.AmrDeal]: 'Deal with AMR',
    [ColumnConfigKey.StaticDeal]: 'Static Deal',
    [ColumnConfigKey.EuCompliance]: 'EU Comp.',
    [ColumnConfigKey.Esg]: 'ESG',
    [ColumnConfigKey.CollateralType]: 'Collat.',
    [ColumnConfigKey.Actions]: 'Actions',
    [ColumnConfigKey.Dealer]: 'Dealer',
    [ColumnConfigKey.Offer]: 'Offer, %',
    [ColumnConfigKey.CreditEnhancement]: 'C/E, %',
    [ColumnConfigKey.OfferDmBps]: 'DM, bps',
    [ColumnConfigKey.OfferYield]: 'Yld, %',
    [ColumnConfigKey.WalYears]: 'WAL',
    [ColumnConfigKey.Mvoc]: 'MVOC, %',
    [ColumnConfigKey.Description]: 'Note',
    [ColumnConfigKey.Coupon]: 'Cur. Coupon',
    [ColumnConfigKey.CurrentCoupon]: 'Cur. Coupon',
    [ColumnConfigKey.Bwic]: 'BWIC',
    [ColumnConfigKey.LastUpdateDate]: 'Last Updated',
    [ColumnConfigKey.CurrentBwic]: 'Current BWIC',
    [ColumnConfigKey.LastTraded]: 'Last Traded',
    [ColumnConfigKey.EvalPriceTalk]: 'K-Talk',
    [ColumnConfigKey.Bid]: 'Bid, %',
    [ColumnConfigKey.BidSize]: 'Bid Size, MM',
    [ColumnConfigKey.BidDmBps]: 'Bid DM, bps',
    [ColumnConfigKey.DealDocuments]: 'Docs',
    [ColumnConfigKey.ImTransaction]: 'Issuance Monitor',
    [ColumnConfigKey.ArrangerPipeline]: 'Arranger Pipeline',
    [ColumnConfigKey.RollerDeadline]: 'Roller Deadline',
    [ColumnConfigKey.CleansingNotice]: 'Cleansing Notice',
    [ColumnConfigKey.KTalkDm]: 'K-Talk DM',
    [ColumnConfigKey.PxTalkDm]: 'Px Talk DM',

    [ColumnConfigKey.LastUpdated]: '',
    [ColumnConfigKey.IssuerName]: '',
    [ColumnConfigKey.Status]: '',
    [ColumnConfigKey.Review]: '',
    [ColumnConfigKey.AnalystUserId]: '',
    [ColumnConfigKey.ArrangerReferenceName]: '',
    [ColumnConfigKey.CoArrangers]: '',
    [ColumnConfigKey.Contacts]: '',
    [ColumnConfigKey.DueDate]: '',
    [ColumnConfigKey.LenderCallDate]: '',
    [ColumnConfigKey.Dataroom]: '',
    [ColumnConfigKey.Facility]: '',
    [ColumnConfigKey.CurrencyCode]: '',
    [ColumnConfigKey.CovLite]: '',
    [ColumnConfigKey.IssuerDescription]: '',
    [ColumnConfigKey.Industry]: '',
    [ColumnConfigKey.UseOfProceeds]: '',
    [ColumnConfigKey.CallProtection]: '',
    [ColumnConfigKey.Guidance]: '',
    [ColumnConfigKey.Price]: '',
    [ColumnConfigKey.Floor]: '',
    [ColumnConfigKey.Margin]: '',
    [ColumnConfigKey.RefIndex]: '',
    [ColumnConfigKey.TrancheRating]: '',
    [ColumnConfigKey.CFRating]: '',
    [ColumnConfigKey.TermYears]: '',
    [ColumnConfigKey.Order]: '',
    [ColumnConfigKey.Target]: '',
    [ColumnConfigKey.Allocation]: '',
    [ColumnConfigKey.AllocationPct]: '',
}
